import { Platform } from "@/data/providers/platform-provider";
import { EditorButtons } from "@/views/editor/editor-type";

export const html: Platform = {
	name: "HTML",
	key: "HTML",
	image: "/assets/images/platforms/html.png",
	icon: "/assets/images/platforms/html-icon.svg",
	color: "blue",
	actions: [EditorButtons.Save, EditorButtons.Popout]
};